<template>
	<div>
		<!-- Filters -->
		<div ref="header" class="posts-filters row align-items-center my-5">
            <div class="col-md-auto">
                <h2 class="mb-md-0">Categories</h2>
            </div>
            <div class="col-md-auto">
                <select :disabled="!!initialCategory" v-model="category" name="category" id="post-category-select" class="form-select mb-md-0">
					<option v-bind:key="cat.slug" v-for="cat in categories" :value="cat.ID || 0" :selected="category == cat.ID">{{cat.name}}</option>
                </select>
            </div>
            <div class="col-md-auto d-none d-md-block">
                <input v-model="search" name="s" type="text" class="form-control" placeholder="Search"/>
            </div>
            <div class="col-md-auto d-none d-md-block">
                <button :disabled="search === ''" type="submit" class="btn btn-primary" v-on:click="fetchData(true)">Search</button>
            </div>
        </div>
		<hr>
		<!-- Posts -->
		<div class="wp-block-columns alignwide posts-loop my-4">
			<posts-loop-item 
				v-for="post of posts" 
				v-bind:key="post.id" 
				:post="post"
			></posts-loop-item>
		</div>
		<!-- Status -->
		<div class="posts-status mb-5">
			<div class="loading" v-if="loading">
				<h2 class="text-center my-5">Loading more posts...</h2>
			</div>
			<div class="empty" v-if="!loading && !posts.length">
				<h2 class="text-center my-5">Nothing to show.</h2>
			</div>
			<div class="actions text-center">
				<button v-if="morePosts" :disabled="loading" class="btn btn-primary" v-on:click="fetchNextPage()">See more</button>
				<button v-if="!morePosts" :disabled="loading" class="btn btn-primary" v-on:click="fetchRefresh()">Refresh</button>
			</div>
		</div>
	</div>
</template>
<script>
import postsLoopItem from './posts-loop-item.vue';
export default {
  	components: { postsLoopItem },
	props: ['initialCategory', 'initialSearch', 'categories', 'initialPosts', 'exclude'],
	data() {
		return {
			loading: true,
			apiBaseUrl: '/wp-json/wp/v2/posts',
			category: 0,
			search: '',
			posts: [],
			perPage: 9,
			page: 1,
			morePosts: true,
		};
	},
	methods: {
		getFetchEndpoint() {
			const url = new URL(window.location.protocol + window.location.host + this.apiBaseUrl);
			const params = new URLSearchParams({
				per_page: this.perPage,
				page: this.page,
				_embed: true // include attachments and taxonomies
			});
			params.forEach((value, key) => url.searchParams.set(key, value));
			if (undefined != this.exclude) {
				url.searchParams.set('exclude', [this.exclude]);
			}
			if (undefined != this.search && this.search.length) {
				url.searchParams.set('search', this.search);
			}
			if (this.category > 0) {
				url.searchParams.set('categories', [this.category]);
			}
			return url.toString();
		},
		fetchData(refresh = false){
			this.loading = true;
			if (refresh) {
				this.page = 1;
			}
			fetch(this.getFetchEndpoint())
				.then(body => body.json())
				.then(data => {
					this.posts = [
						...(refresh ? [] : this.posts),
						...data
					];
					this.morePosts = data.length === this.perPage;
					this.loading = false;
					if (refresh) {
						this.$refs.header.scrollIntoView();
					}
				});
		},
		fetchNextPage() {
			this.fetchData(false);
		},
		fetchRefresh() {
			this.category = 0;
			this.search = '';
			this.fetchData(true);
		}
	},
	watch: {
		category(newValue, oldValue) {
			if (newValue != oldValue) {
				this.fetchData(true);
			}
		}
	},
	created(){
		if (this.initialSearch) {
			this.search = initialSearch;
		}
		if (this.initialCategory) {
			this.category = this.initialCategory;
		}
		this.fetchData();
	}
}
</script>
